;(function () {
  'use strict'

  angular.module('contrast.virtual-patch').constant('VIRTUAL_PATCH', {
    ATTRIBUTES: {
      SELECT: [
        {
          value: 0,
          text: 'User Agent',
          translationId: 'detail_virtualPatchAttribute_userAgent'
        },
        {
          value: 1,
          text: 'Referer',
          translationId: 'detail_virtualPatchAttribute_referer'
        },
        {
          value: 2,
          text: 'URL',
          translationId: 'detail_virtualPatchAttribute_url'
        },
        {
          value: 3,
          text: 'Parameter',
          translationId: 'detail_virtualPatchAttribute_parameter'
        },
        {
          value: 4,
          text: 'Header',
          translationId: 'detail_virtualPatchAttribute_header'
        }
      ]
    },
    CONDITIONS: {
      SELECT: [
        {
          value: 0,
          text: 'matches',
          translationId: 'detail_virtualPatchCondition_matches'
        },
        {
          value: 1,
          text: 'does not match',
          translationId: 'detail_virtualPatchCondition_doesNotMatch'
        },
        {
          value: 2,
          text: 'contains',
          translationId: 'detail_virtualPatchCondition_contains'
        },
        {
          value: 3,
          text: 'does not contain',
          translationId: 'detail_virtualPatchCondition_doesNotContain'
        },
        {
          value: 4,
          text: 'equals',
          translationId: 'detail_virtualPatchCondition_equals'
        },
        {
          value: 5,
          text: 'does not equal',
          translationId: 'detail_virtualPatchCondition_doesNotEqual'
        }
      ],
      ENUM: {
        MATCHES: 0,
        DOES_NOT_MATCH: 1,
        CONTAINS: 2,
        DOES_NOT_CONTAIN: 3,
        EQUALS: 4,
        DOES_NOT_EQUAL: 5
      }
    },
    APPLICATION_MODE: {
      NONE: 0,
      INDIVIDUAL: 1,
      TECHNOLOGY: 2,
      ALL: 3,
      LANGUAGE: 4
    },
    APPLY_TO: {
      APPLICATIONS: 'APPLICATIONS',
      LANGUAGES: 'LANGUAGES',
      TECHNOLOGIES: 'TECHNOLOGIES'
    }
  })
})()
